/**
 * Manages right sidebar shown in webmate.
 */
import {Component, Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {ComponentType} from "@angular/cdk/overlay";
import {Observable} from "rxjs/internal/Observable";

export interface SidebarRightComponent<T> extends ComponentType<T> {
}

export interface SidebarRightConfig {
    sidebarName: string;
}

@Injectable({
    'providedIn': 'root'
})
export class SidebarRightService {
    private sidebarComponentSubject = new BehaviorSubject<[SidebarRightComponent<any>, SidebarRightConfig]>(undefined);

    constructor() {}

    openSidebar<T>(sidebarComponent: ComponentType<T>, sidebarConfig: SidebarRightConfig) {
        this.sidebarComponentSubject.next([sidebarComponent, sidebarConfig]);
    }

    closeSidebar() {
        this.sidebarComponentSubject.next(undefined);
    }

    sidebarComponent$(): Observable<[SidebarRightComponent<any>, SidebarRightConfig]> {
        return this.sidebarComponentSubject.asObservable();
    }

}
